export const VARIANCE_STATUS = Object.freeze({
    PENDING_SM: 1,
    PENDING_AUDIT: 2,
    APPROVED_AUDIT: 3,
    IN_DISCUSSION: 4,
    REJECTED_AUDIT: 5,
    CANCELLED: 98,
    COMPLETED: 99
});

const STATUS_BADGES = {
    1: { variant: "secondary", text: "MENUNGGU DATA PERUBAHAN SM" },
    2: { variant: "warning", text: "MENUNGGU AUDIT" },
    4: { variant: "info", text: "DALAM DISKUSI" },
    5: { variant: "danger", text: "DITOLAK AUDIT" },
    3: { variant: "primary", text: "DISETUJUI AUDIT" },
    98: { variant: "danger", text: "DIBATALKAN" },
    99: { variant: "success", text: "SELESAI" }
};

export function getVarianceStatusBadge(status) {
    return STATUS_BADGES[status] || { variant: "light", text: "-" };
}

export const VARIANCE_STATUS_OPTIONS = [{ value: null, text: "Semua" }].concat(
    [1, 2, 4, 5, 3, 98, 99].map(value => ({ value, text: STATUS_BADGES[value].text }))
);

export const ORIGIN_LABELS = { APPROVAL: "Approval", RESET: "Reset", CONSIGNMENT: "Titip Jual" };

export const ORIGIN_OPTIONS = [{ value: null, text: "Semua" }].concat(
    Object.keys(ORIGIN_LABELS).map(value => ({ value, text: ORIGIN_LABELS[value] }))
);

export const INVENTORY_STATUS = Object.freeze({ PENDING: 1, REQUEST_BUYBACK_PGI: 66 });

// Id fields are compared by `key` but shown by their `display` name key.
export const COMPARE_FIELDS = [
    { key: "item_kind_id", display: "item_kind", label: "Jenis" },
    { key: "item_brand_id", display: "item_brand", label: "Merk" },
    { key: "item_type_id", display: "item_type", label: "Tipe" },
    { key: "year", label: "Tahun" },
    { key: "grade", label: "Grade" },
    { key: "spec_id", display: "spec", label: "Spec" },
    { key: "is_batangan", label: "Kelengkapan" },
    { key: "color_id", display: "color", label: "Warna" },
    { key: "imei_sn", label: "IMEI / SN" },
    { key: "password", label: "Password" },
    { key: "description", label: "Deskripsi" }
];

function isEmpty(value) {
    return value === null || value === undefined || value === "";
}

function normalize(key, value) {
    if (isEmpty(value)) return "";
    if (key === "is_batangan") return String(Boolean(Number(value)));
    return String(value);
}

export function displayField(data, field) {
    if (!data) return "-";
    const value = data[field.display || field.key];
    if (isEmpty(value)) return "-";
    if (field.key === "is_batangan") return Number(value) ? "Batangan" : "Lengkap";
    return String(value);
}

// GA sends kind/type as free text with no ids, so they are reference only.
// Other fields are empty on the GA side and highlight once SM/auditor fills them.
const CONSIGNMENT_REFERENCE_ONLY = ["item_kind_id", "item_type_id"];

export function isFieldDiff(base, other, field, originType) {
    if (!base || !other) return false;
    if (originType === "CONSIGNMENT" && CONSIGNMENT_REFERENCE_ONLY.includes(field.key)) return false;
    return normalize(field.key, base[field.key]) !== normalize(field.key, other[field.key]);
}

export function splitMedia(media) {
    const list = media || [];
    return {
        physical: list.filter(m => m.for === "physical"),
        evidence: list.filter(m => m.for !== "physical")
    };
}

// Grades whose physical photos are required and replace the inventory photos.
export const GRADES_WITH_PHOTO = ["B", "C", "D", "E", "X"];

// Presigned PUT to S3; `path` is what the API stores.
export async function uploadMedia(axios, file, dir, referenceKey) {
    const res = await axios.post("get-presigned-url", {
        file_name: file.name,
        file_type: file.type,
        reference_key: referenceKey,
        directory_path: dir
    });
    const { presigned_url, file_path } = res.data.data;
    const put = await fetch(presigned_url, { method: "PUT", body: file, headers: { "Content-Type": file.type } });
    if (!put.ok) throw new Error("Upload to S3 failed");
    return {
        path: `${dir}/${referenceKey}/${file_path}`,
        type: file.type.startsWith("video/") ? "video" : "image",
        previewUrl: URL.createObjectURL(file)
    };
}
